var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.9375H13.5C14.6 14.9375 15.5 14.0375 15.5 12.9375V2.9375H6.5C5 2.9375 3.69001 3.76749 3.01001 4.98749",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.9375C2.5 19.5975 3.84 20.9375 5.5 20.9375H6.5C6.5 19.8375 7.4 18.9375 8.5 18.9375C9.6 18.9375 10.5 19.8375 10.5 20.9375H14.5C14.5 19.8375 15.4 18.9375 16.5 18.9375C17.6 18.9375 18.5 19.8375 18.5 20.9375H19.5C21.16 20.9375 22.5 19.5975 22.5 17.9375V14.9375H19.5C18.95 14.9375 18.5 14.4875 18.5 13.9375V10.9375C18.5 10.3875 18.95 9.9375 19.5 9.9375H20.79L19.08 6.94751C18.72 6.32751 18.06 5.9375 17.34 5.9375H15.5V12.9375C15.5 14.0375 14.6 14.9375 13.5 14.9375H12.5",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.9375C9.60457 22.9375 10.5 22.0421 10.5 20.9375C10.5 19.8329 9.60457 18.9375 8.5 18.9375C7.39543 18.9375 6.5 19.8329 6.5 20.9375C6.5 22.0421 7.39543 22.9375 8.5 22.9375Z",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.9375C17.6046 22.9375 18.5 22.0421 18.5 20.9375C18.5 19.8329 17.6046 18.9375 16.5 18.9375C15.3954 18.9375 14.5 19.8329 14.5 20.9375C14.5 22.0421 15.3954 22.9375 16.5 22.9375Z",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.9375V14.9375H19.5C18.95 14.9375 18.5 14.4875 18.5 13.9375V10.9375C18.5 10.3875 18.95 9.9375 19.5 9.9375H20.79L22.5 12.9375Z",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.9375H8.5",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.9375H6.5",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.9375H4.5",
    stroke: "#4CAF50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.9fdbe384b9d5f26a29efe167a3c87f5b.svg";
export { ForwardRef as ReactComponent };